import React from 'react'
import { Nav, Wrapper, Link } from './styles'

const Navbar = () => (
	<Nav>
		<Wrapper>
			<Link href='/'>Project GDB</Link>
		</Wrapper>
	</Nav>
)

export default Navbar
